import { graphql, useStaticQuery } from 'gatsby';

const query = graphql`
  query {
    allFile(filter: { absolutePath: { regex: "/images/folio/thumbs/i" } }) {
      edges {
        node {
          name
          childImageSharp {
            fixed(width: 1280, quality: 75) {
              ...GatsbyImageSharpFixed
            }
            fluid(maxWidth: 500, quality: 75) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    }
  }
`;

export default () => useStaticQuery(query).allFile.edges.map(x => x.node);
